import type { ReactNode } from "react";
import { ForgePageLoader } from "@/components/ForgeLoader";
import { AppLayout } from "@/components/layout/AppLayout";
import { useUiUplift } from "@/hooks/useUiUplift";
import { SettingsLayout } from "./SettingsLayout";
import { useScrollToSettingsHash } from "./useScrollToSettingsHash";
import { useSettingsVariantSettled } from "./useSettingsVariantSettled";

/**
 * The layout around SettingsPage (`/settings/:section`). Classic: SettingsLayout, unchanged, with
 * its floating menu. ui_uplift next: the app shell alone, because SettingsPage draws the T5
 * settings nav itself (#6736), so one nav is on screen. The two draw different navs, so neither
 * shows until the organization's flag is known (a failed flag read counts as known, and a viewer
 * with no organization has no flag to wait for: see useSettingsVariantSettled).
 *
 * Other settings routes (directory, integrations) keep SettingsLayout directly.
 */
export function SettingsSectionLayout({ children }: { children: ReactNode }) {
  const isNext = useUiUplift() === "next";
  const variantSettled = useSettingsVariantSettled();

  if (!variantSettled) {
    return (
      <AppLayout>
        <ForgePageLoader />
      </AppLayout>
    );
  }
  if (isNext) return <SettingsNextShell>{children}</SettingsNextShell>;
  return <SettingsLayout>{children}</SettingsLayout>;
}

function SettingsNextShell({ children }: { children: ReactNode }) {
  useScrollToSettingsHash();
  return <AppLayout>{children}</AppLayout>;
}
